export { Template as default } from './Template';
